import React from "react";
import { ArrowPathIcon, EyeSlashIcon, QueueListIcon } from "@heroicons/react/24/outline";
import Section from "./Section";
import SectionHeading from "./SectionHeading";
import FeatureCard from "./FeatureCard";

const ITEMS = [
  {
    icon: ArrowPathIcon,
    title: "Reviews land on whoever's free",
    body: "Not whoever knows the code. Round-robin and load balancing pick an available reviewer, not the right one.",
  },
  {
    icon: EyeSlashIcon,
    title: "You open a PR blind",
    body: "No sense of how big a change really is, or how long it'll take to review, until you're already reading the diff.",
  },
  {
    icon: QueueListIcon,
    title: "Critical changes queue behind trivial ones",
    body: "A one-line config bump and a payments-path rewrite sit in the same undifferentiated queue.",
  },
];

export default function ProblemSection() {
  return (
    <Section id="problem">
      {/*
        The hero already concedes that AI reviews the code and pivots to
        ownership, so this lead deliberately does NOT repeat that beat. It names
        the *wait* instead, which is what the research actually measures:
        LinearB (8.1M PRs, 4,813 teams) found AI-assisted PRs sit ~5x longer
        before a reviewer picks them up — 1,055 min vs 201. Deliberately stated
        without the number: it's someone else's figure, it dates the copy, and
        the three cards below explain the mechanism better than a stat would.
      */}
      <SectionHeading
        eyebrow="The problem"
        title="Review queues don't know what matters"
        lead="AI coding assistants made writing code fast. Now pull requests arrive bigger and more often, into a queue where nothing signals which change needs a careful look — so the ones that matter wait exactly as long as the ones that don't."
      />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {ITEMS.map((item) => (
          <FeatureCard key={item.title} icon={item.icon} title={item.title}>
            {item.body}
          </FeatureCard>
        ))}
      </div>
    </Section>
  );
}
